import React, { useEffect, useRef, useState } from "react";
import styled, { css, keyframes } from "styled-components";
import { LuFlame, LuTicket, LuTrophy } from "react-icons/lu";

// Íconos planos en vez de los sprites 3D de three.js: la lista ya no crea contextos WebGL. En una PC de sala sin
// aceleración gráfica (WebGL por software) con Chrome 156, la app se caía con STATUS_ACCESS_VIOLATION.
const icons = { machine: LuFlame, ticket: LuTicket, trophy: LuTrophy };

const spin = keyframes`
  0%, 70%, 100% { transform: rotateY(0deg); }
  85% { transform: rotateY(180deg); }
`;
const Icon = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 clamp(44px, 4.5vw, 78px);
  width: clamp(44px, 4.5vw, 78px);
  height: clamp(44px, 4.5vw, 78px);
  color: #ffd75e;
  filter: drop-shadow(0 3px 3px #19040080);
  perspective: 200px;
  & > svg {
    width: ${({ $kind }) => ($kind === "machine" ? "60%" : "78%")};
    height: ${({ $kind }) => ($kind === "machine" ? "60%" : "78%")};
    stroke-width: 1.5;
    ${({ $spinning, $delay }) => $spinning && css`
      animation: ${spin} 9s ease-in-out ${$delay}s infinite;
    `}
  }
`;

export default function RaffleTypeModel({ kind = "trophy" }) {
  const ref = useRef(null);
  // Cada tarjeta gira en otro momento.
  const [delay] = useState(() => Math.random() * 6);
  const [visible, setVisible] = useState(false);
  const [pageVisible, setPageVisible] = useState(!document.hidden);
  const [reducedMotion, setReducedMotion] = useState(
    () => window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => setVisible(entry.isIntersecting));
    observer.observe(ref.current);
    const change = () => setPageVisible(!document.hidden);
    const media = window.matchMedia("(prefers-reduced-motion: reduce)");
    const motionChange = () => setReducedMotion(media.matches);
    media.addEventListener("change", motionChange);
    document.addEventListener("visibilitychange", change);
    return () => {
      observer.disconnect();
      document.removeEventListener("visibilitychange", change);
      media.removeEventListener("change", motionChange);
    };
  }, []);
  const Glyph = icons[kind] || LuTrophy;
  return (
    <Icon
      ref={ref}
      aria-hidden="true"
      data-testid="raffle-type-model"
      data-model={kind}
      $spinning={visible && pageVisible && !reducedMotion}
      $delay={delay}
      $kind={kind}
    >
      <Glyph />
    </Icon>
  );
}

